'use client';

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Sprout, BarChart3 } from 'lucide-react';
import SensorCardDemo from './rotate/SensorCardDemo';

const DISPLAY_TEXTS = ['농장 관리 IFMS', '스마트 Control', 'Sensor 모니터링', '환경 제어', 'AI 분석'];

export default function HeroSection() {
  const router = useRouter();
  const [currentText, setCurrentText] = useState(DISPLAY_TEXTS[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      // 이전 텍스트와 겹치지 않게 무작위 선택하는 로직으로 개선 가능
      setCurrentText((prev) => {
        const remaining = DISPLAY_TEXTS.filter(t => t !== prev);
        return remaining[Math.floor(Math.random() * remaining.length)];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-green-50 to-emerald-50 dark:from-gray-900 dark:to-green-900/20 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* 왼쪽 콘텐츠 */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center px-4 py-2 bg-green-100 dark:bg-green-900/30 rounded-full text-green-700 dark:text-green-300 text-sm font-medium mb-6">
              <Sprout className="w-4 h-4 mr-2" />
              스마트 농업의 미래
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-white mb-6">
              AI 지능형 시스템
              <span className="block text-green-600 dark:text-green-400 mt-2 min-h-[1.2em]"> 
                {currentText}
              </span>
            </h1>

            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
              IoT 센서와 AI 기술로 농장을 스마트하게 관리하세요. 실시간 모니터링부터 자동 제어까지, 모든 것을 한눈에.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => router.push('/login')}
                className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1"
              >
                무료로 시작하기
              </button>
              <button
                onClick={() => router.push('/demo')}
                className="px-8 py-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-semibold rounded-lg border-2 border-gray-300 dark:border-gray-600 hover:border-green-500 transition-all duration-200"
              >
                데모 보기
              </button>
            </div>

            {/* 통계 섹션 */}
            <div className="grid grid-cols-3 gap-6 mt-12">
              {[
                { label: '정확도', value: '98%' },
                { label: '모니터링', value: '24/7' },
                { label: '농장 운영', value: '50+' }
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-3xl font-bold text-green-600 dark:text-green-400">{stat.value}</div>
                  <div className="text-sm text-gray-600 dark:text-gray-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 오른쪽 데모 영역 */}
          <div className="relative">
            <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8">
              <SensorCardDemo />
              
              <div className="absolute -top-4 -right-4 p-3 bg-yellow-400 rounded-full shadow-lg animate-bounce">
                <BarChart3 className="w-6 h-6 text-white" />
              </div>
              <div className="absolute -bottom-4 -left-4 p-3 bg-green-500 rounded-full shadow-lg animate-pulse">
                <Sprout className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}